import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Banner.scss';

const Banner = (props) => {
    const classes = classNames('banner', `banner--${props.style}`, {
        'banner--accent': props.leftAccentColor,
    });

    return (
        <div className={classes} style={{ borderColor: props.leftAccentColor }}>
            {props.header && (
                <div className="banner__header eds-text-bl">{props.header}</div>
            )}
            {props.children}
        </div>
    );
};

Banner.propTypes = {
    style: PropTypes.string,
    header: PropTypes.string,
    leftAccentColor: PropTypes.string,
    children: PropTypes.node,
};

export default Banner;
